const VUE_APP_API_GAEA_URL = document.querySelector("html").getAttribute("api_gaea_url");

export default VUE_APP_API_GAEA_URL